import { FC } from 'react';
import { PlatformParams } from './PlatformParams';
import { YandexMetrika } from './YandexMetrika';

interface RouteHandlerProps {
    children: React.ReactNode;
}
  
export const RouteHandler: FC<RouteHandlerProps> = ({ children }) => {   
    return (
        <>
            <PlatformParams />
            <YandexMetrika />
            {children}
        </>
    );
};